import React from "react";

import HexAuthWrapper from "../../components/HexAuthWrapper";
import TopUpReturnRoute from "../../features/finance/TopUpReturnRoute";

const FinanceTopUpReturnPage = () => (
  <div className="finance-topup-return-page full-bleed">
    <HexAuthWrapper>
      <TopUpReturnRoute />
    </HexAuthWrapper>
  </div>
);

export default FinanceTopUpReturnPage;
